module.exports = __webpack_public_path__ + "static/media/viet.93cffefb.svg";